import React from 'react';
import UsersDataMap from '../MapComponents/UsersDataMap';
import HeatMap from '../MapComponents/HeatMap';
import HeatMap2 from '../MapComponents/HeatMap2';

function MapSelector({ mapType, selectedProjectId, selectedQuestionId }) {
    if (mapType === "regular") {
        return <UsersDataMap 
            selectedProjectId={selectedProjectId} 
            selectedQuestionId={selectedQuestionId} 
        />;
    } else if (mapType === "heatmap") {
        return <HeatMap 
            selectedProjectId={selectedProjectId} 
            selectedQuestionId={selectedQuestionId} 
        />;
    } else if (mapType === "heatmap2") {
        return <HeatMap2 
            selectedProjectId={selectedProjectId} 
            selectedQuestionId={selectedQuestionId} 
        />;
    } else {
        return null;
    }
}

export default MapSelector;